import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {HttpModule, Http, XHRBackend, RequestOptions} from '@angular/http';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {ModalModule} from 'ngx-bootstrap';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';

// translate
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';

// layout
import {ControlMessagesComponent} from '../layout/control-messages.component';
import {PageNotFoundComponent} from '../layout/not-found.component';
import {LoginComponent} from '../layout/login/login.component';
import {LeafPageTemplate} from '../layout/templates/page-template.component';

import {SpinnerService} from '../components/spinner/spinner.service';
import {WaitAndLoadComponent} from '../components/wait-and-load/wait-and-load.component';

import {AuthHelper} from '../services/auth.helper';

import {InterceptedHttp} from '../interceptors/http.interceptor';
import {SimpleFormatPipe} from "../pipes/simple-format.pipe";



export class LeafFrameworkShared {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        CommonModule,
        HttpModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ModalModule.forRoot(),
        BsDropdownModule.forRoot(),
        TranslateModule
    ],
    declarations: [
        LoginComponent,
        PageNotFoundComponent,
        ControlMessagesComponent,
        LeafPageTemplate,
        WaitAndLoadComponent,

        SimpleFormatPipe
    ],
    exports: [
        CommonModule,
        HttpModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,
        ModalModule,
        BsDropdownModule,

        LoginComponent,
        PageNotFoundComponent,
        ControlMessagesComponent,
        LeafPageTemplate,
        WaitAndLoadComponent,

        SimpleFormatPipe
    ],
    providers: [
        {provide: Http, useClass: InterceptedHttp, deps: [XHRBackend, RequestOptions, SpinnerService, AuthHelper]}
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
